import { render, staticRenderFns } from "./SettingsEmailFilters.vue?vue&type=template&id=53fda5f6&"
import script from "./SettingsEmailFilters.vue?vue&type=script&lang=js&"
export * from "./SettingsEmailFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports